import { createSlice } from '@reduxjs/toolkit';

import { PAIR_CONFIGS_CACHE_KEY } from 'shared/consts';
import { LocalStorage } from 'tools';
import { IChartRange, IChartTimeframe } from 'types/charts';
import { ECexPairPanel, EDexPairPanel, ESolPairPanel } from 'types/pairs';

export interface IPairConfig {
  statisticAutorefresh?: boolean;
  walletsAutorefresh?: boolean;
  transactionsAutorefresh?: boolean;
  balanceBotAutorefresh?: boolean;
  buysellBotAutorefresh?: boolean;
  dexBuysellSolanaBotAutorefresh?: boolean;
  cexAccountsAutorefresh?: boolean;
  cexOrdersAutorefresh?: boolean;
  cexTradesAutorefresh?: boolean;
  cexStatisticAutorefresh?: boolean;
  cexBuysellBotAutorefresh?: boolean;
  cexOrderManagerAutorefresh?: boolean;
  dexSolanaSlBotAutorefresh?: boolean;
  dexCounterTradeBotAutorefresh?: boolean;
  dexSolanaCounterTradeBotAutorefresh?: boolean;
  dexSolanaDistributionBotAutorefresh?: boolean;
  swapHistoryAutorefresh?: boolean;
  statisticRange?: IChartRange;
  chartTimeframe?: IChartTimeframe;
  lastOpenedPanel?: EDexPairPanel | ECexPairPanel | ESolPairPanel;
  showActiveOrders?: boolean;
  cexBalanceSmoothing?: Record<string, boolean>;
}

interface IPairConfigsState {
  configs: Record<number, IPairConfig>;
}
const pairConfigsInitialState: IPairConfigsState = {
  configs: LocalStorage.get<Record<number, IPairConfig>>(PAIR_CONFIGS_CACHE_KEY) ?? {},
};

const pairConfigsSlice = createSlice({
  name: 'pair_configs',
  initialState: pairConfigsInitialState as IPairConfigsState,
  reducers: {
    setPairConfig: (
      state,
      { payload: { id, config } }: { payload: { id: number; config: IPairConfig } },
    ) => {
      state.configs[id] = config;

      LocalStorage.set(PAIR_CONFIGS_CACHE_KEY, state.configs);
    },
  },
});

export const { setPairConfig } = pairConfigsSlice.actions;

export default pairConfigsSlice.reducer;
